const MWEB_UPI_APP_REDIRECT_FAILURE = "MWEB_UPI_APP_REDIRECT_FAILURE";

export const handleMwebUpiIntentRedirect = (upiIntentUrl: string, orderId: string) => {
    let isUpiAppCurrentlyVisible = false;

    const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            isUpiAppCurrentlyVisible = true;
        }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    // redirect to upi intent app
    window.location.href = upiIntentUrl;

    // using document visibility state to check if user has redirected to upi intent app
    // return failure flag to show error toast message else polling will start
    return new Promise((resolve, reject) => {
        const timeoutId = setTimeout(() => {
            if (!isUpiAppCurrentlyVisible) {
                reject({
                    data: {
                        status: MWEB_UPI_APP_REDIRECT_FAILURE,
                    },
                });
            } else {
                resolve({ orderId });
            }

            // Clean up the visibility change listener
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        }, 3000);

        // Ensure cleanup on page unload
        window.addEventListener("beforeunload", () => {
            clearTimeout(timeoutId);
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        });
    });
};
